/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Client,
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReadOnlyMonitoredObjectGroup
 */
export interface ReadOnlyMonitoredObjectGroup {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectGroup
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectGroup
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectGroup
     */
    color?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectGroup
     */
    monitoredObjectGroupType?: number | null;
    /**
     * 
     * @type {Client}
     * @memberof ReadOnlyMonitoredObjectGroup
     */
    client?: Client;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectGroup
     */
    readonly deleted?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoredObjectGroup
     */
    automaticVehicleAdd?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoredObjectGroup
     */
    readonly deletable?: boolean;
}

export function ReadOnlyMonitoredObjectGroupFromJSON(json: any): ReadOnlyMonitoredObjectGroup {
    return ReadOnlyMonitoredObjectGroupFromJSONTyped(json, false);
}

export function ReadOnlyMonitoredObjectGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoredObjectGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'monitoredObjectGroupType': !exists(json, 'monitored_object_group_type') ? undefined : json['monitored_object_group_type'],
        'client': !exists(json, 'client') ? undefined : ClientFromJSON(json['client']),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'automaticVehicleAdd': !exists(json, 'automatic_vehicle_add') ? undefined : json['automatic_vehicle_add'],
        'deletable': !exists(json, 'deletable') ? undefined : json['deletable'],
    };
}

export function ReadOnlyMonitoredObjectGroupToJSON(value?: ReadOnlyMonitoredObjectGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'color': value.color,
        'monitored_object_group_type': value.monitoredObjectGroupType,
        'client': ClientToJSON(value.client),
        'automatic_vehicle_add': value.automaticVehicleAdd,
    };
}


